import { useState, useCallback } from 'react';
import { integerSort, TEST_CASES } from '../algorithms/integerSort';

/**
 * Hook que encapsula el estado y la lógica del ejercicio integerSort.
 */
export function useIntegerSort() {
  const [input, setInput] = useState('');

  const handleChange = useCallback((value) => {
    setInput(value);
  }, []);

  // Parsea una cadena separada por comas en un arreglo de enteros
  const parsed = input
    .split(',')
    .map((s) => parseInt(s.trim(), 10))
    .filter((n) => !isNaN(n));

  const isValid = parsed.length >= 2;
  const sorted = isValid ? integerSort(parsed) : null;

  const testResults = TEST_CASES.map((tc) => {
    const actual = integerSort(tc.input);
    return {
      ...tc,
      actual,
      pass: JSON.stringify(actual) === JSON.stringify(tc.expected),
    };
  });

  return { input, handleChange, parsed, sorted, isValid, testResults };
}
